<template>
        <grid-x col="1fr 1fr 1fr" row="1fr" gap="2em">
          <div class="col-1">
            <h3>Pages</h3>
            <page-list :data-pages="pages" @page-data="selectPage($event)"></page-list>
            <h3>New Page</h3>
            <div class="new-page">
              <div class="input-box">
                <input v-model="newPageName" type="text" placeholder="New Page Name" ref="newPage">
              </div>
              <button v-on:click="addPage()">Create Page</button>
            </div>
            <div v-if="currentPage.id">
              <h4>Current Page Key</h4>
              <div>{{currentPage.id}}</div>
            </div>
          </div>
          <div class="col-2">
            <h3>Widgets</h3>
            <div v-if="currentPageWidgets">
              <div class="widget-buttons">
                <button v-on:click="refreshWidget(currentPage.id)">UPDATE</button>
                <button v-on:click="testPage(currentPage.id)">TEST</button>
                <span>{{updateWidgetMessage}}</span>
              </div>
              <draggable
                v-model="currentPageWidgets"
                @start="drag=true"
                @end="drag=false"
                @change="reorderWidgetItems"
              >
                <div
                  class="draggable-items flex center-flex-y flex-space-between"
                  v-for="(item,key) in currentPageWidgets"
                  :key="key"
                  :class="activeClass(item.id, currentWidget.id)"
                  @click="selectWidget(item)"
                >
                  <div class="flex center-flex-y">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="draggable-icon"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path fill="none" d="M0 0h24v24H0V0z"></path>
                      <path
                        d="M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
                      ></path>
                    </svg>
                    <span>{{item.data.name}}</span>
                  </div>
                  <button @click="removeWidget(item)">Remove</button>
                </div>
              </draggable>

              <div style="margin-top:50px;">
                <div style="margin-bottom:10px;">
                  <h3>Current Widget Type</h3>
                  <p class="widget-type">Type: {{currentWidget.data.type}}</p>
                  <p class="widget-type">ID: {{currentWidget.id}}</p>
                  <h3>New / Update Widget</h3>
                  <div class="widget-buttons">
                    <button
                      @click="newWidgetButton ='new'"
                      :class="newWidgetButton === 'new' ? 'active-button' : ''"
                    >Create Widget</button>
                    <button
                      v-if="currentWidget"
                      @click="newWidgetButton = 'update'"
                      :class="newWidgetButton === 'update' ? 'active-button' : ''"
                    >Update Current Widget</button>
                  </div>
                </div>
                <div v-if="newWidgetButton === 'new'" class="new-widget-container">
                  <div class="input-box down-caret">
                    <select v-model="newWidgetType" placeholder="Widget Type">
                      <option disabled value>Widget Type</option>
                      <option value="mm-html">HTML</option>
                      <option value="hero">Hero</option>
                      <option value="top-stories">Top Stories</option>
                      <option value="listen">Listen</option>
                      <option value="vertical-article-block">Left-Right Block</option>
                      <option value="three-row-column">Three Articles Bordered</option>
                      <option value="grid-three">Three Column Grid</option>
                      <option value="grid-four">Four Column Grid</option>
                      <option value="capsule-block">Capsule Block</option>
                      <option value="infinite-grid-four">Infinite Scroll Four Grid</option>
                      <option value="horizontal-scroller">Horizontal Scroller</option>
                      <option value="all-podcasts">Podcast Playlist Grid</option>
                      <option value="all-episodes">Podcast Episodes Grid</option>
                      <option value="podcast-carousel">Podcast Carousel</option>
                      <option value="author-carousel">Author Carousel</option>
                      <option value="watch-header">Video Hero</option>
                      <option value="horizontal-scroller-video">Video Horizontal Scroller</option>
                      <option value="all-video-topics">Video Playlist Grid</option>
                      <option value="all-episodes-video">Video Episodes Grid 3</option>
                      <option value="all-videos">Video Episodes Grid 4</option>
                      <option value="title-with-lines">Title With Lines</option>
                      <option value="dynamic-ad-slot">Dynamic Ad Slot</option>
                      <option value="menu-podcasts">MENU Playlists Podcast</option>
                      <option value="menu-video-playlists">MENU Playlists Videos</option>
                    </select>
                  </div>
                  <div class="input-box">
                    <input v-model="newWidgetStyle" type="text" placeholder="New Widget Style">
                  </div>
                  <div class="input-box">
                    <input v-model="newWidgetName" type="text" placeholder="New Widget Name">
                  </div>
                  <div class="input-box">
                    <input v-model="newWidgetLink" type="text" placeholder="New Widget Link">
                  </div>
                  <div class="input-box down-caret">
                    <input type="checkbox" id="newShowTitleCheckbox" v-model="showTitle">
                    <label for="newShowTitleCheckbox">Show Title {{showTitle}}</label>
                  </div>
                  <div v-if="newWidgetType === 'grid-four'" class="input-box">
                    <input type="checkbox" id="newInfinteScrollCheckbox" v-model="infiniteScroll">
                    <label for="newInfinteScrollCheckbox">Infinite Scroll {{infiniteScroll}}</label>
                  </div>
                  <button v-on:click="addWidget()">Save Widget</button>
                </div>

                <div v-if="newWidgetButton === 'update'" class="update-widget-container">
                  <div class="input-box down-caret">
                    <select v-model="currentWidget.data.type" placeholder="Current Widget Type">
                      <option disabled value>Widget Type</option>
                      <option value="mm-html">HTML</option>
                      <option value="hero">Hero</option>
                      <option value="top-stories">Top Stories</option>
                      <option value="listen">Listen</option>
                      <option value="vertical-article-block">Left-Right Block</option>
                      <option value="three-row-column">Three Articles Bordered</option>
                      <option value="grid-three">Three Column Grid</option>
                      <option value="grid-four">Four Column Grid</option>
                      <option value="capsule-block">Capsule Block</option>
                      <option value="infinite-grid-four">Infinite Scroll Four Grid</option>
                      <option value="horizontal-scroller">Horizontal Scroller</option>
                      <option value="all-podcasts">Podcast Playlist Grid</option>
                      <option value="all-episodes">Podcast Episodes Grid</option>
                      <option value="podcast-carousel">Podcast Carousel</option>
                      <option value="author-carousel">Author Carousel</option>
                      <option value="watch-header">Video Hero</option>
                      <option value="horizontal-scroller-video">Video Horizontal Scroller</option>
                      <option value="all-video-topics">Video Playlist Grid</option>
                      <option value="all-episodes-video">Video Episodes Grid 3</option>
                      <option value="all-videos">Video Episodes Grid 4</option>
                      <option value="title-with-lines">Title With Lines</option>
                      <option value="dynamic-ad-slot">Dynamic Ad Slot</option>
                      <option value="menu-podcasts">MENU Playlists Podcast</option>
                      <option value="menu-video-playlists">MENU Playlists Videos</option>
                    </select>
                  </div>
                  <div class="input-box">
                    <input
                      v-model="currentWidget.data.style"
                      type="text"
                      placeholder="Current Widget Styles"
                    >
                  </div>
                  <div class="input-box">
                    <input
                      v-model="currentWidget.data.name"
                      type="text"
                      placeholder="Current Widget Name"
                    >
                  </div>
                  <div class="input-box">
                    <input
                      v-model="currentWidget.data.link"
                      type="text"
                      placeholder="Current Widget Link"
                    >
                  </div>
                  <div class="input-box input-checkbox">
                    <input
                      type="checkbox"
                      id="updateShowTitleCheckbox"
                      v-model="currentWidget.data.showTitle"
                    >
                    <label for="updateShowTitleCheckbox">Show Title {{currentWidget.data.showTitle}}</label>
                  </div>
                  <div v-if="currentWidget.data.type === 'grid-four'" class="input-box input-checkbox">
                    <input
                      type="checkbox"
                      id="updateInfinteScrollCheckbox"
                      v-model="currentWidget.data.infiniteScroll"
                    >
                    <label
                      for="updateInfinteScrollCheckbox"
                    >Infinite Scroll {{currentWidget.data.infiniteScroll}}</label>
                  </div>
                  <button v-on:click="updateWidget()">Update Widget</button>
                </div>
              </div>
            </div>
          </div>
          <div class="flex5">
            <h3>Manage Widget</h3>
            <div v-if="currentWidget" style="padding-left: 10px;">
              <div v-if="currentWidget.data.type == 'mm-html'">
                <div id="editor-container" class="editor-container">
                  <div id="editor-overlay" class="editor-overlay">Changes Saved</div>
                  <div id="editor" class="editor"></div>
                </div>
                <button @click="saveHtml">save</button>
              </div>
              <div v-else-if="currentWidget.data.type == 'dynamic-ad-slot'">
                <span>Placement Name</span>
                <div class="input-box">
                  <input v-model="currentWidget.data.placementName" placeholder="*required">
                </div>
                <button @click="saveAd">save</button>
              </div>
              <div v-else-if="currentWidget.data.type == 'capsule-block'">
                <h2>Custom Data</h2>

                <div id="custom-data-container" class="editor-container">
                  <div id="custom-editor-overlay" class="editor-overlay">Changes Saved</div>
                  <div id="custom-editor" class="editor"></div>
                </div>
                <button @click="saveCustomData">save</button>

              </div>
              <div
                v-else
              >
                <!-- Modals -->
                <modal-create
                  v-if="showModalCreate.add || showModalCreate.edit"
                  @cancel="closeModals"
                  @create="createItem($event)"
                  @update="currentWidget.data.items=$event;updateCurrentWidget();closeModals();"
                  @edit="editItem"
                  :podcasts="podcastPlaylists"
                  :videos="videos"
                  :storage="storage"
                  :currentWidget="currentWidget.data"
                  @setWidgetData="currentWidget.data[$event.key] = $event.value" 
                  :mode="showModalCreate"
                />
                <button v-if="checkMode('category', currentWidget.data.type)" @click="setWidgetMode('category');">Category</button>
                <button v-if="checkMode('curated', currentWidget.data.type)" @click="setWidgetMode('curated');">Curated</button>
                <button v-if="checkMode('tags', currentWidget.data.type)" @click="setWidgetMode('tags');">Tags</button>
                <button v-if="checkMode('podcast', currentWidget.data.type)" @click="setWidgetMode('podcasts');">Podcasts</button>
                <button v-if="checkMode('videos', currentWidget.data.type)" @click="setWidgetMode('videos');">Videos</button>
                <div v-if="currentWidget.data.mode == 'curated'">
                  <h2>Curated</h2>
                  <draggable
                    v-model="currentWidget.data.items"
                    @start="drag=true"
                    @end="drag=false"
                    @change="reorderItems"
                  >
                    <div
                      class="draggable-items flex center-flex-y flex-space-between"
                      v-for="(item,key) in currentWidget.data.items"
                      :key="key"
                    >
                      <div class="flex flex center-flex-y" style="width: 100%;">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          class="draggable-icon"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                        >
                          <path fill="none" d="M0 0h24v24H0V0z"></path>
                          <path
                            d="M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
                          ></path>
                        </svg>
                        <span style="flex:1;">{{item.title}}</span>
                        <button
                          v-if="checkType(currentWidget.data.type, 'podcast') || checkType(currentWidget.data.type, 'video')"
                          @click="removeItem(item, key)"
                        >Remove</button>
                      </div>
                    </div>
                  </draggable>
                  <button
                    style="margin-top:20px;"
                    @click="showModalCreate.add = true;"
                    v-if="confirmAddButtonVisible(currentWidget.data.items)"
                  >Add Items</button>
                  <button
                    style="margin-top:20px;"
                    v-if="confirmEditButtonVisible(currentWidget.data.items) && !checkType(currentWidget.data.type, 'podcast') && !checkType(currentWidget.data.type, 'video')"
                    @click="showModalCreate.edit = true;"
                  >Edit</button>
                </div>

                <div v-if="currentWidget.data.mode == 'category'">
                  <h2>Categories</h2>
                  <div class="input-label">Category</div>
                  <div class="input-box">
                    <input
                      v-model="currentWidget.data.category"
                      type="text"
                      placeholder="Category (Blank for all)"
                    >
                  </div>
                  <div class="input-label">Number of articles</div>
                  <div class="input-box">
                    <input
                      v-model="currentWidget.data.limit"
                      type="text"
                      placeholder="Number of articles"
                    >
                  </div>
                  <div class="input-box down-caret">
                    <select v-model="currentWidget.data.modeOrder" placeholder="Widget Type">
                      <option value="recent">Most Recent</option>
                      <option value="popular">Most Popular</option>
                    </select>
                  </div>
                  <button @click="saveCategoryMode" style="display:block;">Save</button>
                </div>

                <div v-if="currentWidget.data.mode == 'podcasts'">
                  <h2>Podcasts</h2>
                  <div class="input-label">Number of Podcasts</div>
                  <div class="input-box">
                    <input
                      v-model="currentWidget.data.limit"
                      type="text"
                      placeholder="Number of Podcasts"
                    >
                  </div>
                  <div class="input-box down-caret">
                    <select v-model="currentWidget.data.modeOrder" placeholder="Widget Type">
                      <option value="recent">Most Recent</option>
                      <option value="popular">Most Popular</option>
                    </select>
                  </div>
                  <button @click="saveCategoryMode" style="display:block;">Save</button>
                </div>

                <div v-if="currentWidget.data.mode == 'videos'">
                  <h2>Videos</h2>
                  <div class="input-box down-caret">
                    <select v-model="currentWidget.data.playlists" placeholder="Playlists">
                      <option :value="{slug: 'allplaylists', title: 'allplaylists'}">All</option>
                      <option
                        v-for="(item,key) in videos"
                        :value="{slug: item.id, title: item.data.title}"
                        :key="key"
                      >{{ item.title }}</option>
                    </select>
                  </div>
                  <div class="input-label">Number of videos</div>
                  <div class="input-box">
                    <input v-model="currentWidget.data.limit" type="text" placeholder="Number of Videos">
                  </div>
                  <div class="input-box down-caret">
                    <select v-model="currentWidget.data.modeOrder" placeholder="Widget Type">
                      <option value="recent">Most Recent</option>
                      <option value="popular">Most Popular</option>
                    </select>
                  </div>
                  <button @click="saveCategoryMode" style="display:block;">Save</button>
                </div>

                <div v-if="currentWidget.data.mode == 'tags'">
                  <h2>Tags</h2>
                  <div class="input-label">Tag</div>
                  <div class="input-box">
                    <input v-model="currentWidget.data.tags" type="text" placeholder="Tag (ONLY ONE)">
                  </div>
                  <div class="input-label">Number of articles</div>
                  <div class="input-box">
                    <input
                      v-model="currentWidget.data.limit"
                      type="text"
                      placeholder="Number of articles"
                    >
                  </div>
                  <div class="input-box down-caret">
                    <select v-model="currentWidget.data.modeOrder" placeholder="Widget Type">
                      <option value="recent">Most Recent</option>
                      <option value="popular">Most Popular</option>
                    </select>
                  </div>
                  <button @click="saveTagMode" style="display:block;">Save</button>
                </div>
              </div>
            </div>
          </div>
        </grid-x>


</template>
<style scoped>

</style>

<script>
import Vue from "vue";
import firebase from "firebase";
import draggable from "vuedraggable";
import gridX from "../widgets/gridX";
import ModalCreate from "../ModalCreate.vue";
import pageList from "../widgets/pageList";
import config from "../../config.json";
import CodeEditor from "../common/articleWidgets/CodeEditor";

var firestore;
export default {
  name: "widgets",
  components: {
    CodeEditor,
    draggable,
    gridX,
    ModalCreate,
    pageList
  },
  data() {
    firestore = firebase.firestore();
    return {
      storage: firebase.storage(),
      currentPageWidgets: false,
      currentPage: false,
      pages: [],
      updateWidgetMessage: "",
      newWidgetButton: "",
      currentWidgetItems: false,
      currentWidget: "",
      newWidgetStyle: "",
      newWidgetName: "",
      newWidgetLink: "",
      newWidgetType: "",
      newPageName: "",
      showModalCreate: {
        edit: false,
        add: false
      }
    }
  },
  mounted() {
    firestore
      .collection("pages")
      .get()
      .then((snap) => {
        var array = snap.docs.map((doc) => { return {id: doc.id, data: doc.data()} });
        console.log(array);
        this.pages = array;
      });
  },
  methods: {
    closeModals: function() {
      this.showModalCreate.edit = false;
      this.showModalCreate.add = false;
    },
  checkMode: function(mode , type){
     // Checks what mode each widget type can take so the wrong mode won't brake front-end
    //  Only modes that break nuxt are checked so more modes or types may need to be added later
      const validModesForType = {
          'hero': ['curated','category'],
          'listen':['curated','podcast'],
          'top-stories': ['curated','category'],
          'vertical-article-block': ['curated','category'],
          'three-row-column': ['curated','category'],
          'author-carousel': ['curated'],
          'grid-three': ['curated','category','tags'],
          'grid-four': ['curated','category','tags'],
          'infinite-grid-four': ['curated','category','tags'],
          'horizontal-scroller': ['curated','category'],
          'horizontal-scroller-video': ['curated','videos'],
          'all-videos': ['curated','category', 'videos'],
          'all-episodes': ['podcast'],
          'all-episodes-video': ['curated','category','tags','videos'],
          'podcast-carousel': ['curated','category','tags','videos','podcast'],
      };

      if( validModesForType[type] == null ) {
        return false;
      }

      return validModesForType[type].includes(mode);
    },
    checkType: function(type, check) {
      const typesForChecks = {
        'article': [ "curatedArticles", "hero", "top-stories", "vertical-article-block", "three-row-column", "grid-three", "grid-four", "horizontal-scroller"],
        'author': ['author-carousel'],
        'podcast': [ "menu-podcasts", "listen", "all-podcasts", "podcast-carousel" ],
        'video': [ "menu-video-playlists", "all-video-topics" ]
      };
      console.log(type, check);

      // || [] here ensures that if typesForChecks[check] is null we still have an empty array for
      // .includes(type) to execute on
      return (typesForChecks[check] || []).includes(type);
    },
    activeClass: function(a, b) {
      if (a == b) return "active";
      return "";
    },
    reorderItems: function(e) {
      firebase
        .firestore()
        .collection("pages")
        .doc(this.currentPage.id)
        .collection("widgets")
        .doc(this.currentWidget.id)
        .update({
          items: this.currentWidget.data.items
        });
    },
    reorderWidgetItems: function() {
      var count = 0;
      for (var index in this.currentPageWidgets) {
        firebase
          .firestore()
          .collection("pages")
          .doc(this.currentPage.id)
          .collection("widgets")
          .doc(this.currentPageWidgets[index].id)
          .update({
            order: count
          });
        count++;
      }
      // this.$firestore.currentPageWidgets.update({
      //   items: this.currentPageWidgets.items
      // });
    },

    saveHtml: function() {
      firebase
        .firestore()
        .collection("pages")
        .doc(this.currentPage.id)
        .collection("widgets")
        .doc(this.currentWidget.id)
        .update({
          html: this.editor.getSession().getValue()
        })
      .then(function(){
        const overlay = document.getElementById("editor-overlay");
        overlay.classList.toggle('is-visible');
        setTimeout(()=>overlay.classList.toggle('is-visible'), 3000);
      })
      .catch(function(error) {
        console.log(`Data could not be saved: ${error}`);
      });
    },
    saveCustomData: function() {
      firebase
        .firestore()
        .collection("pages")
        .doc(this.currentPage.id)
        .collection("widgets")
        .doc(this.currentWidget.id)
        .update({
          custom: JSON.parse(this.customEditor.getSession().getValue())
        })
      .then(function(){
        const overlay = document.getElementById("custom-editor-overlay");
        overlay.classList.toggle('is-visible');
        setTimeout(()=>overlay.classList.toggle('is-visible'), 3000);
      })
      .catch(function(error) {
        console.log(`Data could not be saved: ${error}`);
      });
    },
    saveAd: function() {
      firebase
        .firestore()
        .collection("pages")
        .doc(this.currentPage.id)
        .collection("widgets")
        .doc(this.currentWidget.id)
        .update({
          placementName: this.currentWidget.data.placementName
        });
    },
    selectPage: function(item) {
      this.currentPage = item;

      firebase
        .firestore()
        .collection("pages")
        .doc(this.currentPage.id)
        .collection("widgets")
        .orderBy("order")
        .get()
        .then((snap) => {
          var array = snap.docs.map((doc) => { return {id: doc.id, data: doc.data()} });
          console.log(array);
          Vue.set(this,"currentPageWidgets", array);
          //console.log(e);
          if (this.currentPageWidgets && this.currentPageWidgets.length > 0) {
            firebase
              .firestore()
              .collection("pages")
              .doc(this.currentPage.id)
              .collection("widgets")
              .doc(this.currentPageWidgets[0].id)
              .get()
              .then((doc) => {
                this.currentWidget = {
                  id: this.currentPageWidgets[0].id,
                  data: doc.data()
                }
              });
          }
        });
      
    },
    removeWidget: function(item) {
      var confirm = window.confirm(
        "Are you sure you would like to delete this widget?"
      );
      if (confirm) {
        firebase
          .firestore()
          .collection("pages")
          .doc(this.currentPage.id)
          .collection("widgets")
          .doc(item.id)
          .delete();
      }
    },

    selectWidget: function(item) {

      Vue.nextTick(() => {

        firebase
          .firestore()
          .collection("pages")
          .doc(this.currentPage.id)
          .collection("widgets")
          .doc(item.id)
          .get()
          .then((doc) => {
            this.currentWidget = {
              id: item.id,
              data: doc.data()
            }
            setTimeout(() => {
              console.log(JSON.stringify(this.currentWidget.data));
              if (document.getElementById("editor")) {
                this.editor = ace.edit("editor");
                this.editor.setTheme("ace/theme/monokai");
                this.editor.session.setMode("ace/mode/html");
                this.editor.setValue(this.currentWidget.data.html);
              }
              if (document.getElementById("custom-editor")) {
                this.customEditor = ace.edit("custom-editor");
                this.customEditor.setTheme("ace/theme/monokai");
                this.customEditor.session.setMode("brace/mode/json");
                this.customEditor.setValue(JSON.stringify(this.currentWidget.data.custom, null, '\t'));
              }
            }, 1000);
          });


      })
    },
    addPage: function() {
      var key = this.newPageName
        .toLowerCase()
        .replace(/\s/g, "-")
        .replace(/[^a-zA-Z\- ]/g, "");
      firebase
        .firestore()
        .collection("pages")
        .doc(key)
        .set({
          name: this.newPageName
        });
      this.newPageName = "";
    },
    createItem: function(itemData) {
      if (!this.currentWidget.data.items) {
        this.currentWidget.data.items = [itemData];
      } else if (this.currentWidget.data.items) {
        this.currentWidget.data.items.push(itemData);
      }
      if (itemData.reorder) {
        this.currentWidget.data.items = itemData.reorder;
      }
      firebase
        .firestore()
        .collection("pages")
        .doc(this.currentPage.id)
        .collection("widgets")
        .doc(this.currentWidget.id)
        .update({
          items: this.currentWidget.data.items
        });
      this.closeModals();
    },

    confirmEditButtonVisible: function(array) {
      if (array) return true;
    },
    lengthValidator: function(maxLength) {
      // this returns a function which checks length against the
      // maxLength param which was passed in when we created the
      // function
      return function(length) {
          return length <= maxLength;
      };
    },
    confirmAddButtonVisible: function(array) {
      if (!array) {
        return true;
      }

      const lengthValidators = {
        "hero": this.lengthValidator(0),
        "listen": this.lengthValidator(2),
        "three-row-column": this.lengthValidator(2),
        "grid-three": this.lengthValidator(2),
        "vertical-article-block": this.lengthValidator(3),
        "grid-four": this.lengthValidator(3),
        "top-stories": this.lengthValidator(0),
        "horizontal-scroller": this.lengthValidator(9)
      };

      if( lengthValidators[this.currentWidget.data.type] == null ) {
        return true;
      }

      return lengthValidators[this.currentWidget.data.type](array.length);
    },
    setWidgetMode: function(mode) {
      Vue.set(this.currentWidget.data, "mode", mode);
      Vue.set(this.currentWidget.data, "modeOrder", "recent");
      this.updateCurrentWidget();
    },
    updateCurrentWidget: function() {
      firebase
        .firestore()
        .collection("pages")
        .doc(this.currentPage.id)
        .collection("widgets")
        .doc(this.currentWidget.id)
        .update(this.currentWidget.data);
    },
    saveCategoryMode: function() {
      this.updateCurrentWidget();
    },
    removeItem: function(item, key) {
      this.currentWidget.data.items.splice(key, 1);
      this.updateCurrentWidget();
      setTimeout(() => {
        this.selectPage(this.currentPage);
      },1000);
    },
    editItem: function(item, key) {
      this.currentWidget.data.items = [item];
      this.updateCurrentWidget();
      this.closeModals();
    },
    openEditItem: function(item, key) {
      this.editData = item;
      this.showModalEdit = true;
    },
    addWidget: function() {
      var key = this.newWidgetName
        .toLowerCase()
        .replace(/\s/g, "-")
        .replace(/[^a-zA-Z\- ]/g, "");
      firebase
        .firestore()
        .collection("pages")
        .doc(this.currentPage.id)
        .collection("widgets")
        .doc(key)
        .set({
          style: this.newWidgetStyle,
          name: this.newWidgetName,
          type: this.newWidgetType,
          order: this.currentPageWidgets.length,
          showTitle: this.showTitle || false,
          infiniteScroll: this.infiniteScroll || false
        }).then(() => {
          this.selectPage(this.currentPage);
        });
      this.newWidgetButton = "";
    },
    updateWidget: function() {
      this.updateCurrentWidget();
      this.newWidgetButton = "";
    },
    testPage: function(key) {
      request
        .get(
          config.apiFrontend + "/getWidgetCollectionData?pageid=" +
            key +
            "&cachebuster=" +
            Date.now()
        )
        .then(response => {
          console.log(response.data);
          var alertMsg = "";
          for (var index in response.data.widgetData) {
            if (response.data.widgetData[index].items)
              alertMsg +=
                index +
                ": " +
                response.data.widgetData[index].items.length +
                "\n";
            else alertMsg += index + ": N/A\n";
          }
          alert(alertMsg);
        });
    },
    refreshWidget: function(key) {
      this.updateWidgetMessage = "Sending, please wait...";
      request
        .get(
          config.apiFrontend + "/refreshPage?slug=" +
            key +
            "&type=widget&cachebuster=" +
            Date.now()
        )
        .then(response => {
          this.updateWidgetMessage = response.data;
        })
        .catch(err => {
          console.log(err);
          this.updateWidgetMessage = "There was an error";
        });
    },
  }
}
</script>



// WEBPACK FOOTER //
// widgets.vue?4a18c595